import { FC } from "react";
import { Drawer, Menu } from 'antd';
import { MenuProps } from 'rc-menu';
import { obtieneMenuItem } from "../../antd-reducer/menu-reducer";
import { navigateToUrl } from "single-spa";
import { IPreHeader } from "../../model/IPreHeader";


type MenuItem = Required<MenuProps>['items'][number];


export const MenuMobile: FC<{ preHeader:IPreHeader , showDrawer:CallableFunction,open: boolean }> = (props) => {


  const onClick: MenuProps['onClick'] = e => {
    props.showDrawer(true)
    navigateToUrl(e.key)
  };
  const items: MenuItem[] = [
    obtieneMenuItem('Inicio', '/'),
    obtieneMenuItem('Comprar', '/vehiculos'),
    obtieneMenuItem('Vender', '/ventas'),
    obtieneMenuItem('Financiamiento', '/financiamiento')
  ];





  return (
    <Drawer
      closable={false} width={"100%"} height={"100%"}
      style={{ marginTop: "56px", width: "100%" }}
      placement="top" open={props.open}>
      <Menu
        onClick={onClick}
        style={{ width: "100%", background: "white", paddingLeft: "28px" }}
        defaultSelectedKeys={['1']}
        mode="inline"
        items={items}
  
      />

      <div style={{ background: "#DBDBDB", height: "100%", width: "100%", paddingLeft: "28px", paddingTop: "28px" }}>


        {
          props.preHeader?.mobile?.map((_, index) => (

            <div key={index}>
            
                <a key={index} id={`anchor-preheader-mobile-${index}`} rel="noreferrer" href={_.link} className='preheader-data-mobile'>
                    {_.text}
                  </a>
                
                
                  <br key={index} />
            </div >

          ))
        }

      </div>
    </Drawer>
  )
}